export const DARK_THEME = 'darkMode';
